import { commonDateParamMappings } from '../../../api/common/mappings';
import { standardQuerySerializer } from '../../../api/serializers';
import type { AiCowbellFactorsDto } from '../../../types/cowbell-factors/ai-cowbell-factors.dto';
import {
  applyQueryConfig,
  makeCancelable,
  ServiceHandler,
} from '../../../utils';

const getCowbellFactorAggregationsHandler = makeCancelable(
  ServiceHandler({
    url: 'api/risk/v1/trend/:accountId',
    paramsSerializer: (params) =>
      standardQuerySerializer(
        applyQueryConfig(commonDateParamMappings, params)
      ),
  })
);
export const getCowbellFactorAggregations = ({
  accountId,
  ...params
}: Record<string, any>) =>
  getCowbellFactorAggregationsHandler(accountId, { params });

const getLatestAiCowbellFactorsHandler = ServiceHandler<
  unknown,
  AiCowbellFactorsDto
>({
  url: '/api/connector/v1/ai-factors/latest',
});
export const getLatestAiCowbellFactors = (accountId: string) =>
  getLatestAiCowbellFactorsHandler({ params: { accountId } });

// applyQueryConfig rebuilds the query from mapped paths only, so accountId has
// to be mapped or it never reaches the endpoint.
export const aiCowbellFactorsHistoryMappings = [
  { path: 'accountId' },
  ...commonDateParamMappings,
];

const getAiCowbellFactorsHistoryHandler = ServiceHandler<
  unknown,
  AiCowbellFactorsDto[]
>({
  url: '/api/connector/v1/ai-factors/history',
  paramsSerializer: (params) =>
    standardQuerySerializer(
      applyQueryConfig(aiCowbellFactorsHistoryMappings, params)
    ),
});
export const getAiCowbellFactorsHistory = (
  accountId: string,
  params: Record<string, unknown> = {}
) => getAiCowbellFactorsHistoryHandler({ params: { accountId, ...params } });

const getLatestQuotesHandler = ServiceHandler({
  url: '/api/quote/v1/latest',
});
export const getLatestQuotes = (params: Record<string, unknown> = {}) =>
  getLatestQuotesHandler({ params });

const getLatestPoliciesHandler = ServiceHandler({
  url: '/api/policy/v1/latest',
});
export const getLatestPolicies = (params: Record<string, unknown> = {}) =>
  getLatestPoliciesHandler({ params });

const getPolicyStatusHandler = ServiceHandler({
  url: '/api/policy/v1/status/:quoteId?product=:product',
});
export const getPolicyStatus = ({
  quoteId,
  product,
}: {
  quoteId: string | number;
  product: string | number;
}) => getPolicyStatusHandler(quoteId, product);

const getLatestClaimsHandler = ServiceHandler({
  url: '/api/claims/v1/latest',
});
export const getLatestClaims = (params: Record<string, unknown> = {}) =>
  getLatestClaimsHandler({ params });

const customerRequestQuoteHandler = ServiceHandler({
  url: '/api/auth/v1/accounts/quote/:agencyId',
  method: 'post',
});
export const customerRequestQuote = (
  { agencyId }: { agencyId: string | number },
  data?: unknown
) => customerRequestQuoteHandler(agencyId, { data });
